import { useDateFormat } from "@vueuse/core"
import { format } from 'date-fns'

export function formatDateTime(value?: string | Date): string {
  if (typeof value === 'string' || value instanceof Date) {
    return useDateFormat(value, 'DD-MM-YYYY HH:mm:ss').value
  } else {
    return ''
  }
}

export function formatDate(value?: string | Date | null): string {
  return typeof value === 'string' || value instanceof Date ? useDateFormat(value, 'DD/MM/YYYY').value : ''
}

export function formatTime(value?: string | Date): string {
  return typeof value === 'string' || value instanceof Date ? useDateFormat(value, 'HH:mm:ss').value : ''
}

export function toDateOnly(value: string | Date): string {
  if (typeof value === 'string') {
    return format(new Date(value), 'yyyy/MM/dd')
  }
  else if (value instanceof Date) {
    return format(value, 'yyyy/MM/dd')
  }
  else {
    throw new Error('Conversion to DateOnly failed for value: ' + value)
  }
}